import React from 'react';
import { PopupWrapperView, MissionDetailsGrid } from '@src/features/order/pages/orders-page/components';
import { CancelledPopupProps } from './types';
import { useUnitType } from '@src/core/features/settings';
import { ArcStack, ArcButton } from '@src/core/ui';
import { OrderMissionEntity } from '@src/features/order/entities';
import OrdersMap from '@src/features/order/pages/orders-page/map';
import { ArcGoogleMap } from '@src/core/controllers';
import { useRepeatOrder } from '@src/features/order/hooks';

const CancelledPopup: React.FC<CancelledPopupProps> = (props) => {
  const { order = {} as OrderMissionEntity } = props;
  // Subscribe so the popup re-renders on a live unit switch — its altitude/speed/
  // distance values are formatted via arcSpatium/arcVelocitas (UNITS Standard R1).
  useUnitType();
  const repeatOrder = useRepeatOrder();

  const onRepeat = () => repeatOrder(order);

  return (
    <PopupWrapperView title={'MISSION DETAILS'}>
      <ArcStack direction='row' spacing={2} width='100%'>
        <ArcStack flex={1} minWidth={0}>
          <MissionDetailsGrid order={order} />

          <ArcStack spacing={1} mt={2}>
            <ArcButton.brand fullWidth onClick={onRepeat}>
              Repeat
            </ArcButton.brand>
          </ArcStack>
        </ArcStack>
        <ArcStack width='336px' borderRadius={1} sx={{ overflow: 'hidden' }}>
          <ArcGoogleMap hideToolbar hideMapControls>
            <OrdersMap />
          </ArcGoogleMap>
        </ArcStack>
      </ArcStack>
    </PopupWrapperView>
  );
};

export default CancelledPopup;
